import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Button, Container, Image, Modal } from "react-bootstrap";
import backarrow from "../../../assets/images/backarrow.jpg";
import mastercard from "../../../assets/images/mastercard.png";
import visa from "../../../assets/images/visa-logo.png";
import styles from "./billinghistory.module.css";

import { Skeleton } from "@mui/material";
import dayjs from "dayjs";

import Sidebar from "../../userflow/components/sidebar/sidebar";
import { useNavigate } from "react-router-dom";
import * as paymentAction from "../../../actions/BillingHistory";
import * as BillingHistoryAction from "../../../actions/Unsubscribe"

const BillingHistory = () => {
  const [showmodal, setShowModal] = useState(false);
  const handlecCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchBillingHistory = async () => {
      setLoading(true);
      try {
        const data = await paymentAction.getBillingHistory();
        setSubscriptions(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBillingHistory();
  }, []);

  async function handleCancelAutoRenew() {
    try {
      const response = await BillingHistoryAction.cancelAutoRenew()
      if (response) {
        handlecCloseModal();
        navigate("/accoutsetting")

      }
    } catch (err) {
      console.error(err);
    }
  }

  async function handleResumeAutoRenew() {
    try {
      const response = await BillingHistoryAction.resumeAutoRenew()
      if (response) {
        setShowResumeModal(false);
        navigate("/accoutsetting")
      }
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
          width: "100%",
          paddingInline: "2rem",
        }}
      >
        <div
          style={{
            width: "100%",
          }}
        >
          <Container className="logo-arrow3">
            <Image
              src={backarrow}
              className="backarrow"
              onClick={() => window.history.back()}
            />
            <h1 className="account-setting-heading">Billing History</h1>
          </Container>

          {loading &&
            Array(5)
              .fill(0)
              .map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rounded"
                  height={100}
                  style={{ marginBlock: "20px", borderRadius: "0.75rem" }}
                />
              ))}

          {subscriptions &&
            subscriptions?.map(subscription => (
              <div key={subscription?.id}>
                {subscription?.status === "active" && (
                  <Container
                    key={subscription.id}
                    style={{
                      marginBlock: "20px",
                      padding: "1.5rem 1rem",
                      cursor: "pointer",
                      filter:
                        subscription.status === "active"
                          ? "none"
                          : "grayscale(1)",
                    }}
                    className={styles["paymentcard"]}
                    onClick={() => {
                      if (subscription.status !== "active") {
                        return;
                      }
                      if (subscription.cancelAtPeriodEnd) {
                        setShowResumeModal(true);
                      } else {
                        handleShowModal();
                      }
                    }}
                  >
                    <div className="row">
                      <div className="col">
                        <span className="d-block text-sm text-muted">
                          {dayjs(subscription.startDate).format("MMM DD, YYYY")}{" "}
                          - {dayjs(subscription.endDate).format("MMM DD, YYYY")}{" "}
                        </span>
                        <span className="d-block text-heading font-bold mb-2">
                          {subscription.name}
                        </span>
                      </div>
                      <div className="col-auto">
                        <div className="d-block text-sm text-muted">
                          {subscription.status.toUpperCase()}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col d-flex justify-content-between">
                        {subscription?.paymentMethod && (
                          <div className="d-flex align-items-center mb-1">
                            <Image
                              src={
                                subscription.paymentMethod.brand === "visa"
                                  ? visa
                                  : mastercard
                              }
                              width={40}
                              height={40}
                              style={{
                                objectFit: "contain",
                              }}
                            />
                            <p>***{subscription.paymentMethod.last4}</p>
                          </div>
                        )}
                        <div className="d-flex align-items-center mb-1">
                          <span>{subscription.price}</span>
                          <span>{subscription.currency.toUpperCase()}</span>
                        </div>
                      </div>
                    </div>
                  </Container>
                )}
              </div>
            ))}

          {!loading && subscriptions?.length === 0 && (
            <div className={styles.noRecordValidation}>
              <h3>No record found</h3>
            </div>
          )}

          <Modal
            className="customer-modal-without-header-footer"
            show={showmodal}
            onHide={handlecCloseModal}
            centered
          >
            <Modal.Body className="pause-modal-content">
              <div className="pause-modal-title">
                Cancel Auto-Renewal on your Subscription?
              </div>
              <div className="pause-modal-message">
                Your account will not auto-renew and your service will be
                interrupted on the expiry date. Keep auto-renew for a seamless
                experience.
              </div>
              <div
                className="d-flex justify-content-center"
                style={{
                  gap: "30px",
                }}
              >
                <button
                  variant="outline-danger"
                  className="global-cancel-button"
                  onClick={handleCancelAutoRenew}
                >
                  Cancel
                </button>
                <button
                  variant="primary"
                  className="global-save-button"
                  onClick={handlecCloseModal}
                >
                  Keep
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            className="customer-modal-without-header-footer"
            show={showResumeModal}
            onHide={() => setShowResumeModal(false)}
            centered
          >
            <Modal.Body className="pause-modal-content">
              <div className="pause-modal-title">
                Turn on Auto-Renewal on your Subscription?
              </div>
              <div className="pause-modal-message">
                Your account will auto-renew and your service will continue
                without interruption.
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  variant="outline-danger"
                  className="btn-no"
                  onClick={() => setShowResumeModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="btn-yes"
                  onClick={handleResumeAutoRenew}
                >
                  Start
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </Sidebar>
  );
};

export default BillingHistory;
